<div *ngIf="isTabletOrMobileView || lastUpdatedAtLabel" class="phx-table-pagination-left">
  <ng-container *ngIf="isTabletOrMobileView; else lastUpdatedTemplate">
    <span class="phx-table-pagination-current-page-count">{{ getCurrentPageCount() }}</span>
    <span *ngIf="hasTotalItems">{{ 'of' | phxTranslate }} {{ totalItems }} {{ 'results' | phxTranslate }}</span>
  </ng-container>

  <ng-template #lastUpdatedTemplate>
    <span>{{ 'Last updated:' | phxTranslate }}</span>
    <div class="phx-table-pagination-last-updated-time-container">
      <span>{{ lastUpdatedAtLabel }}</span>
      <i
        *ngIf="lastUpdatedAtRelativeLabel"
        phx-icon
        [phxIcon]="bulletIcon"
        [color]="'var(--phx-web-color-content-inactive)'"
        [size]="16"
      ></i>
      <span *ngIf="lastUpdatedAtRelativeLabel">{{ lastUpdatedAtRelativeLabel }}</span>
    </div>
  </ng-template>
</div>

<nav class="phx-table-pagination-nav" [attr.aria-label]="'Table pagination' | phxTranslate">
  <ng-container *ngIf="!isTabletOrMobileView">
    <div class="phx-table-pagination-results-count-container">
      <phx-select
        [phxOptions]="selectOptions"
        [ngModel]="perPage"
        [phxShowSearch]="false"
        [phxAllowClear]="false"
        [phxSize]="'extra-small'"
        [phxTriggerTemplate]="perPageSelect"
        [phxTriggerType]="'ghost'"
        [phxVirtualScrollEnabled]="false"
        (phxSelectionChange)="onPerPageChange($event)"
      ></phx-select>

      <ng-template #perPageSelect>
        <button
          class="phx-table-pagination-per-page-select-trigger"
          phx-button
          [phxButtonType]="'ghost'"
          [phxSuffixIcon]="pageSizeChangeIcon"
        >
          {{ getCurrentPageCount() }}
        </button>
      </ng-template>
      <span *ngIf="hasTotalItems" class="phx-table-pagination-of-total-count"
        >{{ 'of' | phxTranslate }} {{ totalItems }} {{ 'results' | phxTranslate }}</span
      >
    </div>
    <phx-divider [phxOrientation]="'vertical'" [phxMarginX]="'extra-large'" [phxMarginY]="'small-medium'"></phx-divider>
  </ng-container>
  <div class="phx-table-pagination-actions-container">
    <span
      class="phx-table-pagination-pages-info"
      [ngClass]="{ 'phx-table-pagination-pages-info-mobile': isTabletOrMobileView }"
      >{{ currentPage }}<ng-container *ngIf="hasTotalItems">
        {{ 'of' | phxTranslate }} {{ totalPages }}</ng-container
      ></span
    >
    <button
      [attr.aria-label]="'Previous page' | phxTranslate"
      phx-icon-button
      phx-tooltip
      [disabled]="isPrevDisabled"
      [phxContent]="'Press < for quick navigation' | phxTranslate"
      [phxIcon]="prevIcon"
      [phxIconButtonSize]="isTabletOrMobileView ? 'medium' : 'extra-extra-small'"
      [phxTooltipMaxWidth]="120"
      [phxTooltipSize]="'small'"
      (click)="onPrev()"
    ></button>
    <button
      [attr.aria-label]="'Next page' | phxTranslate"
      phx-icon-button
      phx-tooltip
      [disabled]="isNextDisabled"
      [phxContent]="'Press > for quick navigation' | phxTranslate"
      [phxIcon]="nextIcon"
      [phxIconButtonSize]="isTabletOrMobileView ? 'medium' : 'extra-extra-small'"
      [phxTooltipMaxWidth]="120"
      [phxTooltipSize]="'small'"
      (click)="onNext()"
    ></button>
  </div>
</nav>
